import React, { useEffect, useState } from "react";
import { STATUS_LABEL, formatSize, hasSize } from "./artGalleryShared";
import { thumbUrl } from "./artGalleryApi";

const GAP_CM = 15;
const WALL_PADDING_PX = 32;
const MIN_ROW_HEIGHT_PX = 90;
const MAX_ROW_HEIGHT_PX = 240;

const useElementWidth = () => {
  const [node, setNode] = useState(null);
  const [width, setWidth] = useState(0);
  useEffect(() => {
    if (!node) return undefined;
    const observer = new ResizeObserver(([entry]) => setWidth(entry.contentRect.width));
    observer.observe(node);
    return () => observer.disconnect();
  }, [node]);
  return [setNode, width];
};

// every piece is drawn at the same px-per-cm so relative sizes are true;
// the scale is picked so the tallest piece lands within a comfortable row height
const ScaleLineup = ({ artworks, onOpen }) => {
  const [wallRef, wallWidth] = useElementWidth();
  const sized = artworks.filter(hasSize);
  const unsized = artworks.length - sized.length;

  if (!sized.length) {
    return (
      <div className="ag-empty">
        Add sizes to artworks to see them side by side at true scale.
      </div>
    );
  }

  const tallest = Math.max(...sized.map((a) => a.heightCm));
  const widest = Math.max(...sized.map((a) => a.widthCm));
  const usableWidth = Math.max(200, wallWidth - WALL_PADDING_PX * 2);
  const pxPerCm = Math.min(
    Math.max(MIN_ROW_HEIGHT_PX, Math.min(MAX_ROW_HEIGHT_PX, usableWidth / 4)) / tallest,
    usableWidth / widest
  );

  return (
    <div className="ag-lineup">
      <div className="ag-lineup-meta">
        <span>
          Showing {sized.length} artwork{sized.length === 1 ? "" : "s"} at true relative scale
          {unsized ? ` · ${unsized} without a size are hidden` : ""}
        </span>
        <div className="ag-scale-bar" style={{ width: 100 * pxPerCm }}>
          <span>1 m</span>
        </div>
      </div>
      <div className="ag-wall" ref={wallRef} style={{ padding: WALL_PADDING_PX }}>
        <div className="ag-wall-row" style={{ columnGap: GAP_CM * pxPerCm, rowGap: GAP_CM * pxPerCm * 2 }}>
          {sized.map((artwork) => (
            <button
              key={artwork._id}
              className="ag-wall-piece"
              onClick={() => onOpen(artwork)}
              title={`${artwork.title || "Untitled"} · ${formatSize(artwork)}`}
            >
              <img
                src={thumbUrl(artwork.croppedImageUrl, 480)}
                alt={artwork.title || "Untitled"}
                style={{ width: artwork.widthCm * pxPerCm, height: artwork.heightCm * pxPerCm }}
              />
              <span className={`ag-badge ag-badge-${artwork.status}`}>{STATUS_LABEL[artwork.status]}</span>
              <span className="ag-wall-caption">
                {artwork.title || "Untitled"}
                <small>{formatSize(artwork)}</small>
              </span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ScaleLineup;
